import { render, staticRenderFns } from "./modelAddUpdateProduct.vue?vue&type=template&id=a3527458&scoped=true&"
import script from "./modelAddUpdateProduct.vue?vue&type=script&lang=js&"
export * from "./modelAddUpdateProduct.vue?vue&type=script&lang=js&"
import style0 from "./modelAddUpdateProduct.vue?vue&type=style&index=0&id=a3527458&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3527458",
  null
  
)

export default component.exports